import clearDigitsSpecialChars from "../parsers/clearDigitsSpecialChars";
import { CELL_FORMATTER_REGEX, CELL_FORMATTER_REGEX_NOT_DD } from "../regex";

export function formatPhone(value, isCell) {
  let rawValue = clearDigitsSpecialChars(value)
  let newValue = ''
  if (rawValue.length > 0) {
      newValue += '(' + rawValue.substr(0, 2)
  }
  if(isCell){
    if (rawValue.length > 2) {
      newValue += ') ' + rawValue.substr(2, 1)
    }
    if(rawValue.length > 3){
      newValue +=  rawValue.substr(3,0) + ' ' + rawValue.substr(3,4)
    }
    if (rawValue.length >= 8) {
      newValue += '-' + rawValue.substr(7, 4)
    }
  }else{
    if (rawValue.length > 2) {
      newValue += ') ' + rawValue.substr(2, 4)
    }
    if(rawValue.length >= 7){
      newValue += '-' + rawValue.substr(6, 4)
    }
  }
  return newValue
}

export function mask(value) {
  const valueClear = clearDigitsSpecialChars(value);
  return mphone(valueClear); 
}

function mphone(value) {
  if (value.length > 10) {
    const valueSliced = value.slice(value.length - 11,)
    value = valueSliced.replace(CELL_FORMATTER_REGEX, "(0$1) $2 $3-$4");
  }
  if (value.length === 9) {
    value = value.replace(CELL_FORMATTER_REGEX_NOT_DD, "$1 $2-$3");
  }
  return value;
}

export default { mask, formatPhone };
